import { TASKS } from 'common/endpoints';
import BaseServiceRetryWrapper from './baseRetry';

class TasksService extends BaseServiceRetryWrapper {
  validateQuestionnairesRequestToken = (requestId: string, token: string): Promise<any> =>
    this.get(TASKS.validateQuestionnairesRequestToken(requestId, token));

  updateQuestionnaireRequestToken = (requestId: string, token: string, data: unknown): Promise<any> =>
    this.post(TASKS.updateQuestionnaireRequestToken(requestId, token), data);

  getQuestionOptions = () => this.get(TASKS.getQuestionOptions());
}

export default TasksService;
